<template>
  <div class="main_center lawEnforcement_detail">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="backRouter">返回</el-button>
      </div>
    </div>
    <div class="right-content busWinessRight">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>举报信息</span>
        </div>
      <el-form :model="form" label-width="200px" ref="form">
        <el-row>
          <el-col :span="num">
            <el-form-item label="项目名称：" prop="projectName">
              {{form.projectName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num / 2">
            <el-form-item label="举报方式：" prop="reportWay">
              {{form.reportWayName}}
            </el-form-item>
          </el-col>
          <el-col :span="num / 2">
            <el-form-item label="举报时间：" prop="reportTime">
              {{form.reportTime}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num / 2">
            <el-form-item label="举报人：" prop="userName">
              {{form.userName}}
            </el-form-item>
          </el-col>
          <el-col :span="num / 2">
            <el-form-item label="身份证号：" prop="idNo">
              {{form.idNo}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num">
            <el-form-item label="居住地址：" prop="userAddress">
              {{form.userAddress}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num / 2">
            <el-form-item label="手机号：" prop="userPhone">
              {{form.userPhone}}
            </el-form-item>
          </el-col>
          <el-col :span="num / 2">
            <el-form-item label="Email：" prop="userEmail">
              {{form.userEmail}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num">
            <el-form-item label="举报内容：" prop="contentText">
              {{form.contentText}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="num" v-for="(item,index) in form.attachments" :key="index" >
            <affix-doc
                    :type="'complaint_reporting_att'"
                    class="affixDown"
                    labelWidth="200px"
                    :name="item.fileTypeName"
                    :item.sync="item"
            />
          </el-col>
        </el-row>


      </el-form>
      </el-card>

    </div>
  </div>
</template>

<script>
  import affixDoc from '@/components/affixDoc';
  import {dealAttachment} from '@/utils';
  import {mapState} from "vuex";
  export default {
    props: ['mainContentViewHeight'],
    components:{
      affixDoc
    },
    data() {
      return {
        visible: false,
        id: "",
        form: {
          id: '',
          projectName: '',
          reportWay: '',
          reportTime: null,
          userName: '',
          idNo:'',
          userAddress:'',
          userPhone:'',
          userEmail:'',
          contentText:'',
          attachments:[]
        },
        num:24,
      }
    },
    computed: {
      ...mapState({
        complaintReportingAttConfig: (state) => state.dataDictionary.complaintReportingAttConfig,
      })
    },
    watch: {
      complaintReportingAttConfig: {
        immediate: true,
        deep: true, // 深度监听
        handler(val, newVal) {
          this.$nextTick(()=>{
            // 初始化附件数据
            let attachments = JSON.parse(JSON.stringify(this.complaintReportingAttConfig));
            this.form.attachments = attachments;
          })

        }
      }
    },
    created() {
      this.$store.dispatch('dataDictionary/getComplaintReportingAttConfig');//获取附件配置项数据
    },
    activated() {
      this.id = (this.$route.query && this.$route.query.id ) || '' ;
      this.init(this.id);
    },
    methods: {
      init(id) {
        this.form.id = id || ''
        this.visible = true
        if (this.form.id) {
          this.$httpReq({
            url: '/complaint_reporting/get?id=' + this.form.id,
            method: 'get'
          }).then(({data}) => {
            let resData = data.data
            if (data && data.code === '1') {
              this.form={...resData};
            }
            // 附件数据处理start
            let attachments= this.complaintReportingAttConfig.length > 0?JSON.parse(JSON.stringify(this.complaintReportingAttConfig)):JSON.parse(JSON.stringify(this.form.attachments));
            this.form.attachments = dealAttachment(attachments,resData.attachments);
          })
        }
      },
      backRouter(){
        this.$refs['form'].resetFields();
        this.form={};
        Object.assign(this.$data.form, this.$options.data().form)
        this.tabsCloseCurrent()
        this.$router.push({name:'complaint_reporting_list'})
      },
    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog{
    width: 600px;
  }
  .el-form{
    margin: 20px 90px 30px 20px;
  }
  .extractorAvoidunit{
    &>div>div>div{
      position: relative;
    }
    .el-input{
      width: 350px;
      margin-left: 15px;
    }
  }

  .el-autocomplete{
    width: 350px;
  }
  .unitTitle{
    position: absolute;
    font-size: 12px;
    top: -16px;
    left: 30px;
    color: #3E8EF7;
    background: #fff;
    height: 14px;
    line-height: 14px;
  }
  .unitTitle2{
    position: absolute;
    font-size: 12px;
    top: -16px;
    left: 300px;
    color: #3E8EF7;
    background: #fff;
    height: 14px;
    line-height: 14px;
  }
  .imgBox{
    cursor: pointer;
    margin: 0 5px;
    width: 20px;
    &:hover{
      background-color: rgba($color: #eee, $alpha: 1);
    }
  }
</style>